import * as React from "react"
import LazyVideo from "@/components/LazyVideo"

const Video = ({
  file,
  type = "video/mp4",
  alt,
  className = "",
  width,
  height,
}) => {
  return (
    <LazyVideo
      className={className}
      type={type}
      alt={alt}
      video={file.default}
      width={width}
      height={height}
      loop={true}
    />
  )
}

export default Video
